<template>
    <div class="metadata-container">
      <div id="panel-capas-header" @click="showHideSection('capas')" >
          <div id="triangle-capas" class="triangle hide"></div>
          <div class="panel-text-section-dark">Campaña</div>
      </div>
      <div id="panel-capas-body" class="hide">
      <ul>
        <div v-if="CampaignSelected != null ">
          <li><p><span class="metadata-blue">Denominación:</span> {{CampaignsList[CampaignSelected].name}}</p></li>
          <li><p><span class="metadata-blue">Fecha:</span> {{CampaignsList[CampaignSelected].date}}</p></li>
          <li><p><span class="metadata-blue">Abstract:</span> {{CampaignsList[CampaignSelected].abstract}}</p></li>
          <li><p><span class="metadata-blue">Objetivo:</span> {{CampaignsList[CampaignSelected].goal}}</p></li>
          <li><p><span class="metadata-blue">Código:</span> {{CampaignsList[CampaignSelected].code}}</p></li>
          <li><p><span class="metadata-blue">Ubicación:</span> {{CampaignsList[CampaignSelected].location}}</p></li>
          <!-- <li><p><span class="metadata-blue">Responsable:</span> {{mosaicsCampaignsList[mosaicCampaignSelected].location}}</p></li> -->
        </div>
      </ul>
      </div>
      <div id="panel-filtered-header"  @click="showHideSection('filtered')">
          <div id="triangle-filtered" class="triangle hide"></div>
          <div class="panel-text-section-dark">Datos de la campaña</div>
      </div>
      <div id="panel-filtered-body" class="hide">
        <div  v-if="CampaignSelected != null " class="input-group ">
                <select v-if="isLayerMosaicsVisible" id="campaign-mosaic" class=" metadata-blue mt-1 mb-3" v-model="mosaicCampaignDataSelected">
                    <option
                      v-for="(campaignData, index) in CampaignsList[CampaignSelected].mosaicCampaignData"
                      :key="index"
                      :label="campaignData.name"
                      :value="index">
                    </option>
                </select>
                <select v-if="isLayerBathymetryVisible" id="campaign-bathy" class=" metadata-blue mt-1 mb-3" v-model="bathymetryCampaignDataSelected">
                    <option
                      v-for="(campaignData, index) in CampaignsList[CampaignSelected].bathymetryCampaignData"
                      :key="index"
                      :label="campaignData.name"
                      :value="index">
                    </option>
                </select>
                <select v-if="isLayerSonarsVisible" id="campaig-sonarn" class=" metadata-blue mt-1 mb-3" v-model="sonarCampaignDataSelected">
                    <option
                      v-for="(campaignData, index) in CampaignsList[CampaignSelected].sonarCampaignData"
                      :key="index"
                      :label="campaignData.name"
                      :value="index">
                    </option>
                </select>
          </div>
        <ul  v-if="CampaignSelected != null ">
          <div v-if="isLayerMosaicsVisible">
            <div v-if="CampaignsList[CampaignSelected].mosaicCampaignData[mosaicCampaignDataSelected] != undefined">
              <li><p><span class="metadata-blue">Fecha:</span> {{CampaignsList[CampaignSelected].mosaicCampaignData[mosaicCampaignDataSelected].date}}</p></li>
              <li><p><span class="metadata-blue">Descripción:</span> {{CampaignsList[CampaignSelected].mosaicCampaignData[mosaicCampaignDataSelected].description}}</p></li>
              <li><p><span class="metadata-blue">Comentarios:</span> {{CampaignsList[CampaignSelected].mosaicCampaignData[mosaicCampaignDataSelected].comments}}</p></li>
            </div>
          </div>
          <div v-if="isLayerBathymetryVisible">
            <div v-if="CampaignsList[CampaignSelected].bathymetryCampaignData[mosaicCampaignDataSelected] != undefined">
              <li><p><span class="metadata-blue">Fecha:</span> {{CampaignsList[CampaignSelected].bathymetryCampaignData[mosaicCampaignDataSelected].date}}</p></li>
              <li><p><span class="metadata-blue">Descripción:</span> {{CampaignsList[CampaignSelected].bathymetryCampaignData[mosaicCampaignDataSelected].description}}</p></li>
              <li><p><span class="metadata-blue">Comentarios:</span> {{CampaignsList[CampaignSelected].bathymetryCampaignData[mosaicCampaignDataSelected].comments}}</p></li>
            </div>
          </div>
          <div v-if="isLayerSonarsVisible">
            <div v-if="CampaignsList[CampaignSelected].sonarCampaignData[mosaicCampaignDataSelected] != undefined">
              <li><p><span class="metadata-blue">Fecha:</span> {{CampaignsList[CampaignSelected].sonarCampaignData[mosaicCampaignDataSelected].date}}</p></li>
              <li><p><span class="metadata-blue">Descripción:</span> {{CampaignsList[CampaignSelected].sonarCampaignData[mosaicCampaignDataSelected].description}}</p></li>
              <li><p><span class="metadata-blue">Comentarios:</span> {{CampaignsList[CampaignSelected].sonarCampaignData[mosaicCampaignDataSelected].comments}}</p></li>
            </div>
          </div>
        </ul>
      </div>
    </div>
</template>

<script>
  // Vuex
  import { mapGetters } from 'vuex'

  export default {
    name: 'panelMetadata',
    data: function () {
        return {
          mosaicCampaignDataSelected: 0,
          bathymetryCampaignDataSelected: 0,
          sonarCampaignDataSelected: 0
        }
    },
    computed: {
      ...mapGetters(['isLayerMosaicsVisible','isLayerBathymetryVisible','isLayerSonarsVisible']),

        CampaignSelected: {
          get () { 
            if(this.isLayerMosaicsVisible)
              return this.$store.state.mapLayers.layerMosaics.mosaicCampaignSelected 
            if(this.isLayerBathymetryVisible)
              return this.$store.state.mapLayers.layerBathymetry.bathymetryCampaignSelected 
            if(this.isLayerSonarsVisible)
              return this.$store.state.mapLayers.layerSonars.sonarCampaignSelected  
          }
        },
        CampaignsList: {
            set (campaignsList) { 
              if(this.isLayerMosaicsVisible)
                this.$store.dispatch('changeMosaicsCampaignsList', {mosaicsCampaignsList: campaignsList})
              if(this.isLayerBathymetryVisible)
                this.$store.dispatch('changeBathymetryCampaignsList', {bathymetryCampaignsList: campaignsList})
              if(this.isLayerSonarsVisible)
                this.$store.dispatch('changeSonarsCampaignsList', {sonarsCampaignsList: campaignsList})
            },
            get () { 
              if(this.isLayerMosaicsVisible)
                return this.$store.state.mapLayers.layerMosaics.mosaicsCampaignsList 
              if(this.isLayerBathymetryVisible)
                return this.$store.state.mapLayers.layerBathymetry.bathymetryCampaignsList
              if(this.isLayerSonarsVisible)
                return this.$store.state.mapLayers.layerSonars.sonarsCampaignsList 
            }
        },
    },
    mounted () {
      
    },
    methods: {
        showHideSection(section){
            var triangle = document.getElementById("triangle-" + section);
            var body = document.getElementById("panel-" + section + "-body");
            triangle.classList.toggle("hide");
            body.classList.toggle("hide");
        },
    }
  }
</script>

<style scoped>
ul {
  font-size: 0.8rem;
  line-height: 1rem;
  padding-left: 1.5rem;
}
li {
  list-style-type: none;
}
.metadata-container{
  margin: .5rem 1rem 0 1rem;
  overflow: hidden;
}
.metadata-title {
  font-weight: bold;
  color: #447998;
  font-size: 0.8rem;
}
.metadata-blue {
  color: #447998;
}

.panel-text-section-dark{
  color: #447998;
  font-size: 0.9rem;
  font-weight: bold;
}

#panel-capas-header, #panel-filtered-header, #panel-filtro-header {
    display: flex;
    flex-direction: row;
    cursor:pointer;
    padding: 5px 0 5px 0;
}
#panel-capas-body, #panel-filtered-body, #panel-filtro-body {
    padding: 0px 10px 0px 0px;
    overflow: hidden;
    height: 100%;

    -webkit-transition: .1s ease-in-out;
    -moz-transition: .1s ease-in-out;
    -o-transition: .1s ease-in-out;
    transition: .1s ease-in-out;
}
#panel-capas-body.hide, #panel-filtered-body.hide, #panel-filtro-body.hide {
    padding: 0;
    height: 0px;
}
.triangle {
    width: 0;
    height: 0;
    border-top: 5px solid transparent;
    border-left: 10px solid #447998;
    border-bottom: 5px solid transparent;
    position: relative;
    top: 7px;
    margin-right: 6px;    

    transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
}
#triangle-capas.hide, #triangle-filtered.hide, #triangle-filtro.hide {
    transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
}
</style>



// WEBPACK FOOTER //
// src/components/map/panelMetadata.vue